import { render, staticRenderFns } from "./ObjectInfoItem.vue?vue&type=template&id=1dd1f705&"
import script from "./ObjectInfoItem.vue?vue&type=script&lang=js&"
export * from "./ObjectInfoItem.vue?vue&type=script&lang=js&"
import style0 from "./ObjectInfoItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports